
const _Hub_Name = "AppointmentPublicHub";

const _Invoke_Methods_Names = {
  appointmentBooking: "BookAppointment",
  appointmentCancellation:"CancelAppointment",
  appointmentReschedule:"RescheduleAppointment",
  appointmentUpdate:"UpdateAppointment",
  appointmentDelete:"DeleteAppointment",
  appointmentComplete:"CompleteAppointment",
};

const _OnReceive_Methods_Names = {
  onAppointmentBookingResponse: "BookAppointmentResponse",
  onAppointmentCancellationResponse:"CancelAppointmentResponse",
  onAppointmentRescheduleResponse:"RescheduleAppointmentResponse",
  onAppointmentUpdateResponse:"UpdateAppointmentResponse",
  onAppointmentDeleteResponse:"DeleteAppointmentResponse",
  onAppointmentCompleteResponse:"CompleteAppointmentResponse",
};

const Public_Appointment_signalr = {
  hubName: _Hub_Name,
  InvokeMethodNames: _Invoke_Methods_Names,
  onReceiveMethodNames: _OnReceive_Methods_Names,
};

export default Public_Appointment_signalr;
